import { defineStore } from 'pinia';
import { useDebugStore } from './debugStore';

export const usePageConfigStore = defineStore('pageConfigStore', {
  state: () => ({
    pageConfig: {},
    changed: false,
  }),
    actions: {
        setPageConfig(route, config) {
            this.changed = true;
            let path = route.matched.length > 0 ? route.matched[0].path : '';
            this.pageConfig[path] = config;
            // after 1 second, set changed to false
            setTimeout(() => {
                this.changed = false;
            }, 1000);
        },
        getPageConfig(route) {
            let path = route.matched.length > 0 ? route.matched[0].path : '';
            let config = this.pageConfig[path];
            const debugStore = useDebugStore();
            if (!config) {
                return {};
            }
            if(!debugStore.showPageDebug){
              config = config.filter(item => item.Hidden !== true);
            }
            return config ? config : {};
        }
    }
});